import React, { useEffect } from 'react';
import './About.scss';
import heroImage from '../../assets/images/hero/hero_image.webp';
import { setPageTitle } from '../../utils/title';
import Breadcrumb from '../../components/Breadcrumb';

const About = () => {
  useEffect(() => {
    setPageTitle('About Us');
  }, []);

  const breadcrumbItems = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About Us' },
  ];

  return (
    <div className="about-page">
      <Breadcrumb items={breadcrumbItems} />
      <section className="page-header">
        <div className="container">
          <h1 className="page-header__title">About Us</h1>
        </div>
      </section>

      <section className="about-section section section--light">
        <div className="container">
          <div className="about-content">
            <div className="about-content__text">
              <h2 className="about-content__title">Who We Are</h2>
              <p className="about-content__description">
                DevSecOps, Inc. is a team of cloud security and compliance experts dedicated to
                helping businesses secure their cloud infrastructure and maintain regulatory
                compliance. We specialize in AWS cloud environments, providing comprehensive
                solutions for SaaS, Data, and AI/ML workloads.
              </p>
              <p className="about-content__description">
                Founded by industry veterans with decades of combined experience in cloud security,
                DevOps practices, and regulatory compliance, we understand the unique challenges
                businesses face in today's rapidly evolving digital landscape.
              </p>
            </div>
            <div className="about-content__image">
              <img src={heroImage} alt="DevSecOps Team" />
            </div>
          </div>
        </div>
      </section>

      <section className="mission-section section">
        <div className="container">
          <div className="mission-content">
            <h2 className="mission-content__title">Our Mission</h2>
            <p className="mission-content__description">
              Our mission is to empower businesses with secure, compliant, and efficient cloud
              infrastructure that enables innovation while protecting sensitive data. We believe
              that security should be an enabler, not a barrier, to technological advancement.
            </p>
            <div className="mission-values">
              <div className="mission-value">
                <h3 className="mission-value__title">Security First</h3>
                <p className="mission-value__description">
                  We prioritize security in everything we do, implementing robust measures to
                  protect your data and systems from evolving threats.
                </p>
              </div>
              <div className="mission-value">
                <h3 className="mission-value__title">Compliance Excellence</h3>
                <p className="mission-value__description">
                  We help you navigate complex regulatory requirements with comprehensive GRC
                  programs tailored to your industry needs.
                </p>
              </div>
              <div className="mission-value">
                <h3 className="mission-value__title">Operational Efficiency</h3>
                <p className="mission-value__description">
                  We optimize your cloud infrastructure to maximize performance while minimizing
                  costs through expert FinOps solutions.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="team-section section section--light">
        <div className="container">
          <h2 className="team-section__title">Our Leadership Team</h2>
          <div className="team-grid">
            <div className="team-member">
              <div className="team-member__image placeholder-image">CEO</div>
              <h3 className="team-member__name">Jane Smith</h3>
              <p className="team-member__title">Chief Executive Officer</p>
              <p className="team-member__bio">
                With over 20 years of experience in cloud security and enterprise IT, Jane leads our
                company's strategic vision and operations.
              </p>
            </div>
            <div className="team-member">
              <div className="team-member__image placeholder-image">CTO</div>
              <h3 className="team-member__name">John Doe</h3>
              <p className="team-member__title">Chief Technology Officer</p>
              <p className="team-member__bio">
                John brings deep technical expertise in AWS architecture, DevSecOps practices, and
                cloud-native technologies.
              </p>
            </div>
            <div className="team-member">
              <div className="team-member__image placeholder-image">CISO</div>
              <h3 className="team-member__name">Sarah Johnson</h3>
              <p className="team-member__title">Chief Information Security Officer</p>
              <p className="team-member__bio">
                Sarah is an expert in information security with specialized knowledge in regulatory
                compliance frameworks.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="cta-section section">
        <div className="container">
          <div className="cta-content">
            <h2 className="cta-content__title">Ready to Secure Your Cloud Infrastructure?</h2>
            <p className="cta-content__description">
              Contact us today to learn how we can help you implement robust security measures and
              achieve regulatory compliance.
            </p>
            <a href="/contact-us" className="btn btn--primary">
              Get in Touch
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
